import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaSun, FaMoon } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
`;

const ThemeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ThemeOption = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  background-color: ${props => props.isSelected ? 'var(--primary-color-light)' : 'var(--bg-secondary)'};
  border: 1px solid ${props => props.isSelected ? 'var(--primary-color)' : 'var(--border-color)'};
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--primary-color-light);
    border-color: var(--primary-color);
  }

  svg {
    font-size: 24px;
  }
`;

const Theme: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [currentTheme, setCurrentTheme] = React.useState<'light' | 'dark'>('light');

  const themes = [
    {
      id: 'light',
      name: t('theme.light'),
      icon: FaSun
    },
    {
      id: 'dark',
      name: t('theme.dark'),
      icon: FaMoon
    }
  ];

  const handleThemeChange = (theme: 'light' | 'dark') => {
    setCurrentTheme(theme);
    // TODO: Implement theme change logic
    // This should update the theme in your theme context/provider
  };

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Title>{t('theme.title')}</Title>

      <ThemeList>
        {themes.map(theme => {
          const Icon = theme.icon;
          return (
            <ThemeOption
              key={theme.id}
              isSelected={currentTheme === theme.id}
              onClick={() => handleThemeChange(theme.id as 'light' | 'dark')}
            >
              <Icon />
              {theme.name}
            </ThemeOption>
          );
        })}
      </ThemeList>
    </Container>
  );
};

export default Theme; 